// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"955294fd","453":"ddc26a5b","732":"ef6febe0"}[chunkId] + ".chunk.js";
};